import { Component, ElementRef, Injector, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { MenuService } from '../../core/menu/menu.service';
import { IState } from '@state/state.module';
import { AuthService } from '@shared/services/auth/auth.service';
import { EnableEngageCookieService } from '@shared/services/auth/enable-engage-cookie.service';
import { EngageRedirectService } from '../header/engage-redirect.service';
import { Logger } from '@services/logging/logger';
declare let $: any;

@Component({
    selector: 'app-horizontal',
    templateUrl: './horizontal.component.html',
    styleUrls: ['./horizontal.component.scss']
})
export class HorizontalComponent implements OnInit, OnDestroy {

    @ViewChildren('menuItem') items!: QueryList<ElementRef>;

    public menuItems: Array<any>;
    public router: Router;
    public openMenu = false;
    public activeIndex: number | null = null;
    public activeParentIndex: number | null = null;
    protected isSupport = true;
    protected isEngagePreferred = false;

    private readonly destroy$ = new Subject<void>();

    constructor(
        public menuService: MenuService,
        public injector: Injector,
        private readonly store: Store<IState>,
        private readonly authService: AuthService,
        private readonly enableEngage: EnableEngageCookieService,
        private readonly engageRedirect: EngageRedirectService
    ) {}

    public ngOnInit() {
        this.menuItems = this.menuService.menuItems;
        this.router = this.injector.get(Router);
        this.isEngagePreferred = this.enableEngage.read() ?? false;

        this.router.events
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                window.scrollTo(0, 0);
            });

        this.store.select(state => state.app.profile)
            .pipe(
                takeUntil(this.destroy$),
                filter(profileState => !profileState.pending)
            )
            .subscribe(profile => {
                this.isSupport = profile.isSupport ?? true;
            });
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onToggleSubmenuClick(event: MouseEvent, index?: number): void {
        event.preventDefault();

        this.activeIndex = index;
        this.activeParentIndex = index ?? this.activeParentIndex;
        this.openMenu = true;
    }

    closeMenu(): void {
        this.openMenu = false;
        this.activeIndex = null;
    }

    protected toggleEngage(event: Event) {
        event.preventDefault();

        if (this.enableEngage.read()) {
            this.switchToClassic();
            return;
        }

        this.switchToEngage();
    }

    private switchToClassic(): void {
        this.enableEngage.write(false);
        this.isEngagePreferred = false;
    }

    private switchToEngage(): void {
        const tenantId = this.authService.retrieveToken()?.decoded?.ten;
        if (!tenantId) {
            Logger.warn('HorizontalComponent.switchToEngage: tenantId missing, cannot navigate to Engage');
            return;
        }

        this.enableEngage.write(true);
        this.isEngagePreferred = true;
        this.engageRedirect.redirectToEngage(this.router.url, tenantId, 'HorizontalComponent.switchToEngage');
    }
}
